import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Trans} from "react-i18next";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";


const useStyles = makeStyles(({
  grid: {
  },
  imageContainer: {
    width: '100%',
    flexGrow: 0
  },
  'link': {
    boxShadow: '0px 3px 6px #00000029;',
    backgroundColor: 'white',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
    color: '#373737',
    textAlign: 'center',
    textDecoration: 'none',
    '& img': {
       display: 'block'
    },
    '& h2': {
      margin: 0,
      textTransform: 'uppercase',
      font: 'normal normal bold 15px/17px Helvetica'
    },
    '& p': {
      font: 'normal normal normal 15px/20px Helvetica',
      textAlign: 'center',
      margin: '8px 0 0 0',
      flexGrow: 1
    }
  }
}))

export default ({data}) => {
  const classes = useStyles();

  return <Container>
    <Grid container spacing={3}  direction="row">
      {data.categories
          .filter( category => category.category != 'photobook')
          .map(category => {
        return <Grid container item md={4} sm={6} xs={12} key={category.category}
                     className={classes.grid} flex={1} direction="column">
          <a className={classes.link} href={category.link}>
            <div className={classes.imageContainer}>
              <img src={category.image} width={'100%'}/>
            </div>
            <Box p={2} width={1} flexGrow={1}>
              <h2>{category.title}</h2>
              <p>{category.text}</p>
            </Box>
          </a>
        </Grid>
      })}
    </Grid>
  </Container>
}